// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SafetyHookModel from '../../model/safety-hook-model';
import SafetyHookDTO from '../dto/safety-hook-dto';
import dtoSchema from '../schemas/safety-hook-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SafetyHookModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SafetyHookDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.name = data.name ?? undefined;
      this.groupName = data.groupName ?? undefined;
      this.screwType = data.screwType ?? undefined;
      this.safetyHookType = data.safetyHookType ?? undefined;
      this.standardScrewThickness = data.standardScrewThickness;
      this.standardScrewLength = data.standardScrewLength;
      this.counterbattenScrewLength = data.counterbattenScrewLength;
      this.minimumScrewDepth = data.minimumScrewDepth;
      this.canFastenOnCounterbatten = data.canFastenOnCounterbatten;
      this.screwConnectionMustBeDocumented = data.screwConnectionMustBeDocumented;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  name?: string;
  /**
  */
  groupName?: string;
  /**
  */
  screwType?: string;
  /**
  */
  safetyHookType?: string;
  /**
  * @type {int32}
  */
  standardScrewThickness?: number;
  /**
  * @type {int32}
  */
  standardScrewLength?: number;
  /**
  * @type {int32}
  */
  counterbattenScrewLength?: number;
  /**
  * @type {int32}
  */
  minimumScrewDepth?: number;
  /**
  */
  canFastenOnCounterbatten?: boolean;
  /**
  */
  screwConnectionMustBeDocumented?: boolean;

  static toModel(dto: DeepPartial<SafetyHookDTO>): SafetyHookModel;
  static toModel(dto: DeepPartial<SafetyHookDTO> | undefined | null): SafetyHookModel | undefined;
  static toModel(dto: DeepPartial<SafetyHookDTO> | undefined | null): SafetyHookModel | undefined {
    return dto ? new SafetyHookModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SafetyHookModel> | SafetyHookModel): SafetyHookDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      name: unwrapped.name,
      groupName: unwrapped.groupName,
      screwType: unwrapped.screwType,
      safetyHookType: unwrapped.safetyHookType,
      standardScrewThickness: unwrapped.standardScrewThickness,
      standardScrewLength: unwrapped.standardScrewLength,
      counterbattenScrewLength: unwrapped.counterbattenScrewLength,
      minimumScrewDepth: unwrapped.minimumScrewDepth,
      canFastenOnCounterbatten: unwrapped.canFastenOnCounterbatten,
      screwConnectionMustBeDocumented: unwrapped.screwConnectionMustBeDocumented,
    } as SafetyHookDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SafetyHookModel, can not map to SafetyHookDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
